import { BillingPlanFeaturesEnumV2 } from 'gql/types'

export const isBillingPlanFeaturesEnumV2 = (value: unknown): value is BillingPlanFeaturesEnumV2 =>
  Object.values<unknown>(BillingPlanFeaturesEnumV2).includes(value)
